import axiosInstance from '../../utils/axiosConfig';
import {getOrganizationDetails} from "./party";
import { createUserGroup } from "./user.js";
export const FETCH_REPAIRERS_REQUEST = 'FETCH_REPAIRERS_REQUEST';
export const FETCH_REPAIRERS_SUCCESS = 'FETCH_REPAIRERS_SUCCESS';
export const FETCH_REPAIRERS_FAILURE = 'FETCH_REPAIRERS_FAILURE';

export const FILTER_REPAIRERS_REQUEST = 'FILTER_REPAIRERS_REQUEST';
export const FILTER_REPAIRERS_SUCCESS = 'FILTER_REPAIRERS_SUCCESS';
export const FILTER_REPAIRERS_FAILURE = 'FILTER_REPAIRERS_FAILURE';

export const fetchRepairers = () => async (dispatch) => {
    dispatch({ type: FETCH_REPAIRERS_REQUEST });
    try {
        const repairersResponse = await axiosInstance.post(process.env.REACT_APP_BACKEND_URL_MS_REPAIRSHOPMANAGEMENT + '/repairer/filterRepairShops');
        const repairers = repairersResponse.data;

        const organizationRequests = repairers.map((repairer) =>
            axiosInstance.get(process.env.REACT_APP_BACKEND_URL_MS_PARTY + `/organisation/GetOrganizationDetails/${repairer.associatedParty}`)
        );

        const organizationsResponses = await Promise.all(organizationRequests);
        const organizations = organizationsResponses.map((response) => response.data);
        // console.log('organizations : ',organizations)
        const repairersWithOrgNames = repairers.map((repairer) => {
            const organization = organizations.find((org) => org.uid === repairer.associatedParty);//by uid
            return {
                ...repairer,
                organizationName: organization ? organization.organizationName : 'Unknown',
                taxId: organization ? organization.taxId : '',
            };
        });   
        const repairersWithDetails = repairersWithOrgNames.map((repairer) => {
             
             
const ChannelPhone = organizations.partyCommunicationChannels?.find(party => party.communicationChannel?.type === "PHONECONTACT" &&  party.status === "ACTIVE");
    const phoneNumber = ChannelPhone ? ChannelPhone.communicationChannel.value : "N/A"
    const ChannelEmail = organizations.partyCommunicationChannels?.find(party => party.communicationChannel?.type === "PHONECONTACT" &&  party.status === "ACTIVE");
    const email = ChannelEmail ? ChannelEmail.communicationChannel.value : "N/A"
            return {
                ...repairer,
                email: email || 'N/A',
                phoneNumber: phoneNumber || 'N/A',
            };
        });

        dispatch({
            type: FETCH_REPAIRERS_SUCCESS,
            payload: repairersWithDetails,
        });
        // console.log('repairersWithDetails : ',repairersWithDetails)
        return repairersWithDetails;
    } catch (error) {
        dispatch({
            type: FETCH_REPAIRERS_FAILURE,
            payload: error.message,
        });
    }
};


export const filterRepairers = (filters) => async (dispatch) => {
    dispatch({ type: FILTER_REPAIRERS_REQUEST });

    try {
        const repairersResponse = await axiosInstance.post(`${process.env.REACT_APP_BACKEND_URL_MS_REPAIRSHOPMANAGEMENT}/repairer/filter`, filters);
        const repairers = repairersResponse.data; 

        const organizationRequests = repairers.map((repairer) =>
            axiosInstance.get(process.env.REACT_APP_BACKEND_URL_MS_PARTY+`/organisation/GetOrganizationDetails/${repairer.associatedParty}`)
    );

        const organizationsResponses = await Promise.all(organizationRequests);
        const organizations = organizationsResponses.map((response) => response.data);

        const repairersWithOrgNames = repairers.map((repairer) => {
            // const organization = organizations.find((org) => org._id === repairer.associatedParty);
            const organization = organizations.find((org) => org.uid === repairer.associatedParty);//by uid
            return {
                ...repairer,
                organizationName: organization ? organization.organizationName : 'Unknown',
                organization :organization || 'N/A'   ,
                taxId: organization ? organization.taxId : '',
            };
        });
        
        
        dispatch({
            type: FILTER_REPAIRERS_SUCCESS,
            payload: repairersWithOrgNames,
        });
        return repairersWithOrgNames ;
    } catch (error) {
        dispatch({
            type: FILTER_REPAIRERS_FAILURE,
            payload: null,
        });
        return null ;
    }
};

export const createRepairer = async (organizationData, repairerData) => {
    try {
        // console.log("organizationData", organizationData)
        // console.log("repairerData", repairerData)
        //communicationChannel
        const communicationChannelsToCreate = [
            {type: "PHONECONTACT", value: organizationData?.phoneNumber},
            {type: "EMAILCONTACT", value: organizationData?.email}
        ]
        const communicationChannelsPromises = communicationChannelsToCreate.map(payload =>
            axiosInstance.post(
                `${process.env.REACT_APP_BACKEND_URL_MS_PARTY}/communicationChannel/CreateCommunicationChannel`,
                payload)
        );

        const communicationChannelResponses = await Promise.all(communicationChannelsPromises)
        const communicationChannelIds = communicationChannelResponses.map(
            response => response?.data._id
        );

        const today = new Date();
        const organizationPayload = {
            partyCommunicationChannels: communicationChannelIds,
            organizationName: organizationData?.organizationName,
            daaq: '/',
            creationDate: today,
            activity: "REPAIRE_SHOP",
            taxId: organizationData?.taxId,
            code : organizationData?.codePI
        };

        //organization
        const organizationResponse = await axiosInstance.post(
            `${process.env.REACT_APP_BACKEND_URL_MS_PARTY}/organisation/CreateOrganization`,
            organizationPayload
        );

        const organization = organizationResponse?.data;
        const associatedParty = organization?.uid;
        // create groupe for organization
        const groupData = {
            label: organizationData?.organizationName,
            uid: associatedParty,
          };
        let newGroup = await createUserGroup(groupData);
        console.log("organization Group", newGroup)
        
        //communicationChannelParty
        for (const channelId of communicationChannelIds) {
            const communicationChannelParty = {
                uid: associatedParty,
                communicationChannelId: channelId,
            };

            await axiosInstance.post(
                `${process.env.REACT_APP_BACKEND_URL_MS_PARTY}/partyCommunicationChannel/AddCommunicationChannelToParty`,
                communicationChannelParty
            );
        }

        // characteristics
        const characteristicsToCreate = [
            ...repairerData.region.map(region => ({
                key: "REGION",
                value: region })),
            ...repairerData.gouvernorat.map(gouvernorat => ({
                key: "GOUVERNORAT",
                value: gouvernorat })),
            ...repairerData.scope.map(scopeItem => ({
                key: "SCOPE",
                value: scopeItem,
            })),
        ];

        const characteristicPromises = characteristicsToCreate.map(payload =>
            axiosInstance.post(
                `${process.env.REACT_APP_BACKEND_URL_MS_REPAIRSHOPMANAGEMENT}/repairerCaracteristique/create`,
                payload
            )
        );

        const characteristicsResponses = await Promise.all(characteristicPromises);
        const characteristicsIds = characteristicsResponses.map(
            response => response?.data?._id
        );

        //performancekpi
        const performanceKpiPayload = {
            missionsInProgress: 0,
            averageReparationCost: 0,
            hourlyReplacementRate: 0,
            totalSameBrandVehicleRepaired: 0,
            hourlyRepairRate: 0,
        }

        const performanceKpiResponse = await axiosInstance.post(
            `${process.env.REACT_APP_BACKEND_URL_MS_REPAIRSHOPMANAGEMENT}/performanceKpi/create`,
            performanceKpiPayload
        );
        const performanceKpiId = performanceKpiResponse?.data?._id
        // console.log("performanceKpiResponse", performanceKpiResponse)
        // console.log("performanceKpiId", performanceKpiId)

        //repairer
        const repairerPayload = {
            associatedParty,
            performanceKpi: performanceKpiId,
            caracteristiques: characteristicsIds,
            additionalData:{
                idRepairerGroup : newGroup?._id,
            }
        };
        const phoneContact = communicationChannelsToCreate.find(channel => channel.type === 'PHONECONTACT')  ;
        const adresse = characteristicsToCreate.find(channel => channel.type === 'REGION')  ;

      const garageStarEx = {
          name: organizationData?.organizationName,
          location: adresse? adresse.value: "",
          tel: phoneContact ? phoneContact.value : ""
      };
        const garageStarExApi = await axiosInstance.post(
            `${process.env.REACT_APP_BACKEND_URL_EXPERT_MISSION}/Garage/addGarage`,
            garageStarEx
        );
        console.log("garageStarExApi", garageStarExApi?.data)
        const repairerResponse = await axiosInstance.post(
            `${process.env.REACT_APP_BACKEND_URL_MS_REPAIRSHOPMANAGEMENT}/repairer/create`,
            repairerPayload
        );
        console.log("repairerResponse", repairerResponse)
        
        return repairerResponse.data;
    } catch (error) {
        console.error('Error creating repairer:', error);
        throw error;
    }
};

export const deleteRepairer = async (repairerId) => {
    try {
        // Fetch the repairer details
        const repairerResponse = await axiosInstance.get(
            `${process.env.REACT_APP_BACKEND_URL_MS_REPAIRSHOPMANAGEMENT}/repairer/getById/${repairerId}`
        );

         const repairer = repairerResponse?.data;
        console.log("repairer", repairer)

        if (!repairer) {
            throw new Error(`Repairer with ID ${repairerId} not found`);
        }

        // get the party of the repairer
        const associatedParty = repairer.associatedParty;
        console.log("associatedParty", associatedParty)
        // Fetch the organization details
        const organizationResponse = await axiosInstance.get(
            `${process.env.REACT_APP_BACKEND_URL_MS_PARTY}/organisation/GetOrganizationDetails/${associatedParty}`
        );
        const organization = organizationResponse?.data;
        console.log("organization", organization)


        if (!organization) {
            throw new Error(`Organization with ID ${associatedParty} not found`);
        }
     
     
        //delete the party
        await axiosInstance.delete(
            `${process.env.REACT_APP_BACKEND_URL_MS_PARTY}/party/${associatedParty}`
        );
        // Delete characteristics
        const characteristicsPromises = repairer.caracteristiques.map(characteristic =>
            axiosInstance.delete(
                `${process.env.REACT_APP_BACKEND_URL_MS_REPAIRSHOPMANAGEMENT}/repairerCaracteristique/delete/${characteristic._id}`
            )
        );
        await Promise.all(characteristicsPromises);

        // Delete performance KPI
        if (repairer.performanceKpi && repairer.performanceKpi._id) {
            await axiosInstance.delete(
                `${process.env.REACT_APP_BACKEND_URL_MS_REPAIRSHOPMANAGEMENT}/performanceKpi/delete/${repairer.performanceKpi._id}`
            );
        }

        // Delete equipments
        if (repairer.equipments && repairer.equipments.length > 0) {
            const equipmentsPromises = repairer.equipments.map(equipment =>
                axiosInstance.delete(
                    `${process.env.REACT_APP_BACKEND_URL_MS_REPAIRSHOPMANAGEMENT}/equipment/delete/${equipment._id}`
                )
            );
            await Promise.all(equipmentsPromises);
        }


        // Delete the repairer
        await axiosInstance.delete(
            `${process.env.REACT_APP_BACKEND_URL_MS_REPAIRSHOPMANAGEMENT}/repairer/delete/${repairerId}`
        );

        console.log(`Repairer with ID ${repairerId} and associated data deleted successfully`);
        return { success: true };
    } catch (error) {
        console.error('Error deleting repairer:', error);
        throw error;
    }
};

export const updateRepairer = async (repairerId, updatedData) => {
    try {
        // console.log("repairerId", repairerId);
        // console.log("updatedData", updatedData);

        const repairerResponse = await axiosInstance.get(
            `${process.env.REACT_APP_BACKEND_URL_MS_REPAIRSHOPMANAGEMENT}/repairer/getById/${repairerId}`
        );
        const repairer = repairerResponse?.data;
        //console.log("repairer", repairer)
        if (!repairer) {
            throw new Error(`Repairer with ID ${repairerId} not found`);
        }

        const party = await getOrganizationDetails(repairer?.associatedParty);
        //console.log("party", party);
        if (!party) {
            throw new Error(`Party with UID ${repairer.associatedParty} not found`);
        }

        if (party.partyCommunicationChannels.length === 0) {
            console.log("partyCommunicationChannels is empty. Creating new communication channels...");

            const communicationChannelsToCreate = [];

            if (updatedData.phoneNumber) {
                communicationChannelsToCreate.push({
                    type: "PHONECONTACT",
                    value: updatedData.phoneNumber,
                });
            }

            if (updatedData.email) {
                communicationChannelsToCreate.push({
                    type: "EMAILCONTACT",
                    value: updatedData.email,
                });
            }

            if (communicationChannelsToCreate.length > 0) {
                const communicationChannelsPromises = communicationChannelsToCreate.map((payload) =>
                    axiosInstance.post(
                        `${process.env.REACT_APP_BACKEND_URL_MS_PARTY}/communicationChannel/CreateCommunicationChannel`,
                        payload
                    )
                );

                const communicationChannelResponses = await Promise.all(communicationChannelsPromises);
                const communicationChannelIds = communicationChannelResponses.map(
                    (response) => response?.data._id
                );


                const organizationPayload = {
                    organizationName: updatedData.organizationName,
                    taxId: updatedData.taxId,
                    partyCommunicationChannels: communicationChannelIds,
                };
                console.log("organizationPayload", organizationPayload)

                await axiosInstance.put(
                    `${process.env.REACT_APP_BACKEND_URL_MS_PARTY}/organisation/UpdateOrganization/${repairer.associatedParty}`,
                    organizationPayload
                );

                for (const channelId of communicationChannelIds) {
                    const communicationChannelParty = {
                        uid: repairer.associatedParty,
                        communicationChannelId: channelId,
                    };

                    await axiosInstance.post(
                        `${process.env.REACT_APP_BACKEND_URL_MS_PARTY}/partyCommunicationChannel/AddCommunicationChannelToParty`,
                        communicationChannelParty
                    );
                }

                console.log("New communication channels created and linked to the party.");
            } else {
                console.log("No new communication channels to create.");
            }
        }
        else if (party.partyCommunicationChannels.length > 0){
            //update communication channels if provided
            if (updatedData.phoneNumber || updatedData.email) {
                const partyCommunicationChannels = party?.partyCommunicationChannels;
                const communicationUpdates = [];

                for (const partyChannel of partyCommunicationChannels) {
                    const partyChannelId = partyChannel?._id;

                    const partyChannelResponse = await axiosInstance.get(
                        `${process.env.REACT_APP_BACKEND_URL_MS_PARTY}/partyCommunicationChannel/GetPartyCommunicationChannelDetails/${partyChannelId}`
                    );
                    const channelId = partyChannelResponse?.data?.communicationChannel;

                    const channelResponse = await axiosInstance.get(
                        `${process.env.REACT_APP_BACKEND_URL_MS_PARTY}/communicationChannel/GetCommunicationChannelDetails/${channelId}`
                    );
                    const channelDetails = channelResponse?.data;

                    // Update phone number
                    if (
                        updatedData.phoneNumber &&
                        channelDetails.type === "PHONECONTACT" &&
                        channelDetails.value !== updatedData.phoneNumber &&
                        channelDetails.value !== "N/A"
                    ) {
                        communicationUpdates.push(
                            axiosInstance.put(
                                `${process.env.REACT_APP_BACKEND_URL_MS_PARTY}/communicationChannel/UpdateCommunicationChannel/${channelId}`,
                                { type: "PHONECONTACT", value: updatedData.phoneNumber }
                            )
                        );
                    }

                    // Update email
                    if (
                        updatedData.email &&
                        channelDetails.type === "EMAILCONTACT" &&
                        channelDetails.value !== updatedData.email &&
                        channelDetails.value !== "N/A"
                    ) {
                        communicationUpdates.push(
                            axiosInstance.put(
                                `${process.env.REACT_APP_BACKEND_URL_MS_PARTY}/communicationChannel/UpdateCommunicationChannel/${channelId}`,
                                { type: "EMAILCONTACT", value: updatedData.email }
                            )
                        );
                    }
                }

                if (communicationUpdates.length > 0) {
                    await Promise.all(communicationUpdates);
                }
            }
        }

        const organizationPayload = {
            organizationName: updatedData.organizationName,
            taxId: updatedData.taxId,
        };
        console.log("organizationPayload", organizationPayload)

        await axiosInstance.put(
            `${process.env.REACT_APP_BACKEND_URL_MS_PARTY}/organisation/UpdateOrganization/${repairer.associatedParty}`,
            organizationPayload
        );


        const caracteristiqueUpdates = [];
        const existingCaracteristiquesMap = new Map(
            repairer.caracteristiques.map((item) => [`${item.key}-${item.value}`, item])
        );

        const updatedCaracteristiquesMap = new Map(
            updatedData.caracteristiques.map((item) => [`${item.key}-${item.value}`, item])
        );

        for (const updatedCaracteristique of updatedData.caracteristiques) {
            const key = `${updatedCaracteristique.key}-${updatedCaracteristique.value}`;

            if (!existingCaracteristiquesMap.has(key)) {
                const existingCaracteristique = repairer.caracteristiques.find(
                    (item) =>
                        item.key === updatedCaracteristique.key &&
                        item.value !== updatedCaracteristique.value
                );

                 const createCaracteristiquePromise = axiosInstance
                        .post(
                            `${process.env.REACT_APP_BACKEND_URL_MS_REPAIRSHOPMANAGEMENT}/repairerCaracteristique/create`,
                            { key: updatedCaracteristique.key, value: updatedCaracteristique.value }
                        )
                        .then((response) => {
                            // Add the newly created characteristic to the repairer
                            return axiosInstance.post(
                                `${process.env.REACT_APP_BACKEND_URL_MS_REPAIRSHOPMANAGEMENT}/repairer/addCaracteristiqueToRepairer`,
                                {
                                    repairerId: repairer._id,
                                    caracteristiqueId: response.data._id,
                                }
                            );
                        });

                    caracteristiqueUpdates.push(createCaracteristiquePromise);
                }
            }

        for (const existingCaracteristique of repairer.caracteristiques) {
            const key = `${existingCaracteristique.key}-${existingCaracteristique.value}`;

            if (!updatedCaracteristiquesMap.has(key)) {
                caracteristiqueUpdates.push(
                    axiosInstance.delete(
                        `${process.env.REACT_APP_BACKEND_URL_MS_REPAIRSHOPMANAGEMENT}/repairerCaracteristique/delete/${existingCaracteristique._id}`
                    )
                );
            }
        }

        if (caracteristiqueUpdates.length > 0) {
            await Promise.all(caracteristiqueUpdates);
        }

    } catch (error) {
        console.error("Error updating repairer:", error);
        throw error;
    }
};
